import { safeParse, safeStringify } from 'utils';

export const SESSION_STORAGE_KEYS = {
  DOWNLOAD_UNIQUE_ID: 'downloadUniqueId',
  SL_DOWNLOAD_UNIQUE_ID: 'slDownloadUniqueId',
};

export default {
  ram: {} as Record<string, string>,
  setItem(key: string, value: Record<string, any> | string | boolean) {
    try {
      sessionStorage.setItem(key, safeStringify(value));
    } catch (e) {
      this.ram[key] = safeStringify(value);
    }
  },
  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      this.ram[key] = undefined;
    }
  },
  getItem<T>(key: string): T {
    const sessionStorageItem = safeParse(sessionStorage.getItem(key));

    if (sessionStorageItem !== undefined) return sessionStorageItem;

    return safeParse(this.ram[key]);
  },
};
